// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__12egQ","footer":"ModalError_footer__1Gh5_"};